var _templateObject;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { createGlobalStyle } from "styled-components";
import INGMeWebRegular from "./INGMeWeb-Regular.woff";
import INGMeWebBold from "./INGMeWeb-Bold.woff";
export var IngFonts = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @font-face {\n    font-family: 'ING Me Web';\n    src: url(", ") format('woff');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: 'ING Me Web';\n    src: url(", ") format('woff');\n    font-weight: 700;\n    font-style: normal;\n  }\n"])), INGMeWebRegular, INGMeWebBold);